import React from 'react';
import { Frame, Tooltip } from '@kajabi/sage-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CommonQuantitySelector from 'apps/commerce/common/components/QuantitySelector/QuantitySelector';

const QuantitySelector = () => {
  const { setValue, getValues, watch } = useFormContext();
  const { quantityRemaining } = getValues();
  const quantity = watch('quantity');
  const offer = watch('offer');
  const { t } = useTranslation();

  // Handle quantity updates from the common component
  const handleUpdateQuantity = React.useCallback(
    (newQuantity) => {
      const validQuantity = newQuantity < 1 ? 1 : parseInt(newQuantity, 10);
      setValue('quantity', Number(validQuantity));
    },
    [setValue],
  );

  const Heading = () => (
    <div className="quantity-selector__heading">
      <span className="quantity-selector__title">{t('form.quantity')}</span>
    </div>
  );
  const atMaxQuantity = quantity === quantityRemaining;
  const WrapperComponent = atMaxQuantity ? Tooltip : React.Fragment;
  const ToolTipProps = atMaxQuantity
    ? { content: t('form.quantity_limit_reached'), position: 'top' }
    : {};

  return (
    <Frame
      direction={Frame.DIRECTIONS.HORIZONTAL}
      align={Frame.ALIGNMENTS.CENTER_SPREAD}
      gap={Frame.GAPS.XS}
      className="embedded-checkout-price-display"
    >
      <Heading />
      <WrapperComponent {...ToolTipProps}>
        <CommonQuantitySelector
          itemQuantity={quantity}
          handleUpdateQuantity={handleUpdateQuantity}
          quantityEnabled={true}
          item={offer}
          isQuantityLimitReached={atMaxQuantity}
        />
      </WrapperComponent>
    </Frame>
  );
};

export default QuantitySelector;
